/**
 * @generated SignedSource<<7a84d6a418f4fa6661bc756ce1b0e27e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type latestVideoQuery$data = {
  readonly videoTop: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: string;
          readonly entityId?: string;
          readonly " $fragmentSpreads": FragmentRefs<"helpersGetVideoYoutubeIdVideo" | "hooksTrackCurrentItemBase" | "videoListGridCardContent" | "videoPrimaryContent">;
        };
        readonly " $fragmentSpreads": FragmentRefs<"videoUpNextWidgetVideo">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "latestVideoQuery";
};
export type latestVideoQuery$key = {
  readonly " $data"?: latestVideoQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"latestVideoQuery">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "bodyType",
    "variableName": "bodyType"
  },
  {
    "kind": "Variable",
    "name": "customContents",
    "variableName": "customContents"
  }
],
v3 = [
  (v1/*: any*/)
],
v4 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "contentShareWidgetContent"
},
v5 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "Section",
  "abstractKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = [
  (v7/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v10 = [
  (v1/*: any*/),
  (v7/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": (v10/*: any*/),
          "type": "Section",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "kind": "InlineFragment",
  "selections": (v8/*: any*/),
  "type": "Section",
  "abstractKey": null
},
v13 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegmentV2",
      "kind": "LinkedField",
      "name": "sectionsV2",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            (v5/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
},
v14 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "entityLink"
},
v15 = [
  {
    "defaultValue": "PARAGRAPH",
    "kind": "LocalArgument",
    "name": "bodyType"
  },
  {
    "defaultValue": ([]/*: any*/),
    "kind": "LocalArgument",
    "name": "customContents"
  }
],
v16 = [
  (v4/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "videoLatestQueueName"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "latestVideoQuery",
  "selections": [
    {
      "alias": "videoTop",
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "name",
              "variableName": "videoLatestQueueName"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        }
      ],
      "concreteType": "Queue",
      "kind": "LinkedField",
      "name": "queue",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 29
            }
          ],
          "concreteType": "QueueItemConnection",
          "kind": "LinkedField",
          "name": "items",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "QueueItemsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v1/*: any*/),
                        {
                          "kind": "InlineDataFragmentSpread",
                          "name": "helpersGetVideoYoutubeIdVideo",
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "youtubeId",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "VideoSource",
                              "kind": "LinkedField",
                              "name": "videoSource",
                              "plural": true,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "id",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "type",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "args": null,
                          "argumentDefinitions": []
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "videoListGridCardContent"
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "videoPrimaryContent"
                        }
                      ],
                      "type": "Video",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "hooksTrackCurrentItemBase",
                      "selections": [
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v0/*: any*/),
                            {
                              "kind": "InlineDataFragmentSpread",
                              "name": "atomsCurrentArticleAtomBase",
                              "selections": [
                                (v0/*: any*/),
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    {
                                      "kind": "InlineDataFragmentSpread",
                                      "name": "articleHeadlineHeaderFeaturesContent",
                                      "selections": [
                                        {
                                          "alias": null,
                                          "args": null,
                                          "kind": "ScalarField",
                                          "name": "headline",
                                          "storageKey": null
                                        },
                                        {
                                          "alias": null,
                                          "args": null,
                                          "kind": "ScalarField",
                                          "name": "socialHeadline",
                                          "storageKey": null
                                        }
                                      ],
                                      "args": null,
                                      "argumentDefinitions": []
                                    },
                                    {
                                      "args": (v2/*: any*/),
                                      "kind": "FragmentSpread",
                                      "name": "articleSeoArticle"
                                    },
                                    {
                                      "args": null,
                                      "kind": "FragmentSpread",
                                      "name": "articleShareWidgetArticle"
                                    },
                                    {
                                      "kind": "InlineDataFragmentSpread",
                                      "name": "bookmarkHeaderFeaturesContent",
                                      "selections": (v3/*: any*/),
                                      "args": null,
                                      "argumentDefinitions": []
                                    },
                                    {
                                      "kind": "InlineDataFragmentSpread",
                                      "name": "commentHeaderFeaturesArticle",
                                      "selections": [
                                        {
                                          "kind": "InlineFragment",
                                          "selections": [
                                            {
                                              "args": null,
                                              "kind": "FragmentSpread",
                                              "name": "articleCommentsTriggerArticle"
                                            }
                                          ],
                                          "type": "Article",
                                          "abstractKey": null
                                        }
                                      ],
                                      "args": null,
                                      "argumentDefinitions": []
                                    },
                                    (v4/*: any*/),
                                    {
                                      "kind": "InlineDataFragmentSpread",
                                      "name": "helpersCheckIsStyleArticle",
                                      "selections": [
                                        {
                                          "alias": null,
                                          "args": null,
                                          "concreteType": "SectionSegmentV2",
                                          "kind": "LinkedField",
                                          "name": "sectionsV2",
                                          "plural": true,
                                          "selections": [
                                            {
                                              "alias": null,
                                              "args": null,
                                              "concreteType": null,
                                              "kind": "LinkedField",
                                              "name": "value",
                                              "plural": true,
                                              "selections": [
                                                (v5/*: any*/),
                                                {
                                                  "kind": "InlineFragment",
                                                  "selections": (v3/*: any*/),
                                                  "type": "VideoSection",
                                                  "abstractKey": null
                                                }
                                              ],
                                              "storageKey": null
                                            }
                                          ],
                                          "storageKey": null
                                        }
                                      ],
                                      "args": null,
                                      "argumentDefinitions": []
                                    },
                                    {
                                      "kind": "InlineDataFragmentSpread",
                                      "name": "helpersUseSharingUrl",
                                      "selections": [
                                        (v6/*: any*/)
                                      ],
                                      "args": null,
                                      "argumentDefinitions": []
                                    },
                                    {
                                      "kind": "InlineDataFragmentSpread",
                                      "name": "hooksContentInterestArticle",
                                      "selections": [
                                        (v0/*: any*/),
                                        (v1/*: any*/),
                                        (v6/*: any*/),
                                        (v9/*: any*/),
                                        {
                                          "kind": "InlineFragment",
                                          "selections": [
                                            {
                                              "alias": null,
                                              "args": null,
                                              "kind": "ScalarField",
                                              "name": "sentiment",
                                              "storageKey": null
                                            },
                                            {
                                              "alias": null,
                                              "args": null,
                                              "concreteType": "ArticleTypeSegment",
                                              "kind": "LinkedField",
                                              "name": "types",
                                              "plural": true,
                                              "selections": [
                                                {
                                                  "alias": null,
                                                  "args": null,
                                                  "concreteType": "ArticleType",
                                                  "kind": "LinkedField",
                                                  "name": "value",
                                                  "plural": true,
                                                  "selections": (v8/*: any*/),
                                                  "storageKey": null
                                                }
                                              ],
                                              "storageKey": null
                                            }
                                          ],
                                          "type": "Article",
                                          "abstractKey": null
                                        }
                                      ],
                                      "args": null,
                                      "argumentDefinitions": []
                                    },
                                    {
                                      "args": null,
                                      "kind": "FragmentSpread",
                                      "name": "hooksTrackPageViewArticle"
                                    },
                                    {
                                      "kind": "InlineDataFragmentSpread",
                                      "name": "hooksUseCurrentArticleIdsArticle",
                                      "selections": [
                                        (v1/*: any*/),
                                        {
                                          "alias": null,
                                          "args": null,
                                          "kind": "ScalarField",
                                          "name": "entityUuid",
                                          "storageKey": null
                                        }
                                      ],
                                      "args": null,
                                      "argumentDefinitions": []
                                    },
                                    {
                                      "kind": "InlineDataFragmentSpread",
                                      "name": "hooksUseCurrentArticlePrebidConfigArticle",
                                      "selections": [
                                        {
                                          "kind": "InlineFragment",
                                          "selections": [
                                            (v11/*: any*/),
                                            (v9/*: any*/)
                                          ],
                                          "type": "Article",
                                          "abstractKey": null
                                        }
                                      ],
                                      "args": null,
                                      "argumentDefinitions": []
                                    },
                                    {
                                      "kind": "InlineDataFragmentSpread",
                                      "name": "hooksUsePageTargetingArticle",
                                      "selections": [
                                        {
                                          "kind": "InlineFragment",
                                          "selections": [
                                            {
                                              "alias": null,
                                              "args": null,
                                              "concreteType": "SectionSegmentV2",
                                              "kind": "LinkedField",
                                              "name": "sectionsV2",
                                              "plural": true,
                                              "selections": [
                                                {
                                                  "alias": null,
                                                  "args": null,
                                                  "concreteType": null,
                                                  "kind": "LinkedField",
                                                  "name": "value",
                                                  "plural": true,
                                                  "selections": [
                                                    (v12/*: any*/)
                                                  ],
                                                  "storageKey": null
                                                }
                                              ],
                                              "storageKey": null
                                            },
                                            {
                                              "alias": null,
                                              "args": null,
                                              "concreteType": "Topic",
                                              "kind": "LinkedField",
                                              "name": "firstTopic",
                                              "plural": false,
                                              "selections": (v8/*: any*/),
                                              "storageKey": null
                                            }
                                          ],
                                          "type": "Article",
                                          "abstractKey": null
                                        }
                                      ],
                                      "args": null,
                                      "argumentDefinitions": []
                                    },
                                    {
                                      "kind": "InlineDataFragmentSpread",
                                      "name": "onboardingNewsletterSubscriptionArticle",
                                      "selections": [
                                        (v13/*: any*/)
                                      ],
                                      "args": null,
                                      "argumentDefinitions": []
                                    },
                                    {
                                      "kind": "InlineDataFragmentSpread",
                                      "name": "entityLinkHeaderFeaturesArticle",
                                      "selections": [
                                        {
                                          "kind": "InlineFragment",
                                          "selections": [
                                            {
                                              "alias": null,
                                              "args": null,
                                              "concreteType": "Author",
                                              "kind": "LinkedField",
                                              "name": "authors",
                                              "plural": true,
                                              "selections": [
                                                (v7/*: any*/),
                                                (v14/*: any*/)
                                              ],
                                              "storageKey": null
                                            },
                                            {
                                              "alias": null,
                                              "args": null,
                                              "concreteType": "SectionSegmentV2",
                                              "kind": "LinkedField",
                                              "name": "sectionsV2",
                                              "plural": true,
                                              "selections": [
                                                {
                                                  "alias": null,
                                                  "args": null,
                                                  "concreteType": null,
                                                  "kind": "LinkedField",
                                                  "name": "value",
                                                  "plural": true,
                                                  "selections": [
                                                    {
                                                      "kind": "InlineFragment",
                                                      "selections": [
                                                        (v7/*: any*/),
                                                        {
                                                          "alias": null,
                                                          "args": null,
                                                          "kind": "ScalarField",
                                                          "name": "published",
                                                          "storageKey": null
                                                        },
                                                        (v14/*: any*/)
                                                      ],
                                                      "type": "Section",
                                                      "abstractKey": null
                                                    }
                                                  ],
                                                  "storageKey": null
                                                }
                                              ],
                                              "storageKey": null
                                            }
                                          ],
                                          "type": "Article",
                                          "abstractKey": null
                                        }
                                      ],
                                      "args": null,
                                      "argumentDefinitions": []
                                    },
                                    {
                                      "kind": "InlineDataFragmentSpread",
                                      "name": "shareHeaderFeaturesContent",
                                      "selections": [
                                        {
                                          "args": null,
                                          "kind": "FragmentSpread",
                                          "name": "shareArticle20Content"
                                        }
                                      ],
                                      "args": null,
                                      "argumentDefinitions": []
                                    },
                                    {
                                      "kind": "InlineDataFragmentSpread",
                                      "name": "helpersRosettaArticleContextArticle",
                                      "selections": [
                                        (v9/*: any*/),
                                        {
                                          "alias": null,
                                          "args": null,
                                          "concreteType": "SectionSegmentV2",
                                          "kind": "LinkedField",
                                          "name": "sectionsV2",
                                          "plural": true,
                                          "selections": [
                                            {
                                              "alias": null,
                                              "args": null,
                                              "concreteType": null,
                                              "kind": "LinkedField",
                                              "name": "value",
                                              "plural": true,
                                              "selections": [
                                                (v12/*: any*/),
                                                {
                                                  "kind": "InlineFragment",
                                                  "selections": (v8/*: any*/),
                                                  "type": "VideoSection",
                                                  "abstractKey": null
                                                }
                                              ],
                                              "storageKey": null
                                            }
                                          ],
                                          "storageKey": null
                                        }
                                      ],
                                      "args": null,
                                      "argumentDefinitions": []
                                    }
                                  ],
                                  "type": "Content",
                                  "abstractKey": "__isContent"
                                }
                              ],
                              "args": (v2/*: any*/),
                              "argumentDefinitions": (v15/*: any*/)
                            },
                            {
                              "kind": "InlineDataFragmentSpread",
                              "name": "atomsCurrentShareContentAtomBase",
                              "selections": [
                                (v0/*: any*/),
                                {
                                  "kind": "InlineFragment",
                                  "selections": (v16/*: any*/),
                                  "type": "Article",
                                  "abstractKey": null
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": (v16/*: any*/),
                                  "type": "Video",
                                  "abstractKey": null
                                }
                              ],
                              "args": null,
                              "argumentDefinitions": []
                            },
                            {
                              "kind": "InlineDataFragmentSpread",
                              "name": "atomsCurrentStyleCardCarouselWidgetSectionsAtomBase",
                              "selections": [
                                (v0/*: any*/),
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    (v11/*: any*/)
                                  ],
                                  "type": "Article",
                                  "abstractKey": null
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "Section",
                                      "kind": "LinkedField",
                                      "name": "fullSectionPath",
                                      "plural": true,
                                      "selections": (v10/*: any*/),
                                      "storageKey": null
                                    }
                                  ],
                                  "type": "Section",
                                  "abstractKey": null
                                }
                              ],
                              "args": null,
                              "argumentDefinitions": []
                            },
                            {
                              "kind": "InlineDataFragmentSpread",
                              "name": "atomsCurrentTakeoverAdSectionsAtomBase",
                              "selections": [
                                (v0/*: any*/),
                                (v13/*: any*/),
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "Section",
                                      "kind": "LinkedField",
                                      "name": "fullSectionPath",
                                      "plural": true,
                                      "selections": (v3/*: any*/),
                                      "storageKey": null
                                    }
                                  ],
                                  "type": "Section",
                                  "abstractKey": null
                                }
                              ],
                              "args": null,
                              "argumentDefinitions": []
                            }
                          ],
                          "type": "BaseWithApplicationAndUrlAlias",
                          "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                        }
                      ],
                      "args": null,
                      "argumentDefinitions": (v15/*: any*/)
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "videoUpNextWidgetVideo"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "items(first:29)"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "4cdf38701307103735ac2b73ff56d2a2";

export default node;
